import { Tabs } from "@etudescarre/ui";
import { Link, useLocation } from "react-router";

export function AdminNav() {
  const location = useLocation();

  // Determine active tab based on current path
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === "/admin" || path === "/admin/yards") return "yards";
    if (path.startsWith("/admin/companies")) return "companies";
    if (path.startsWith("/admin/contracts")) return "contracts";
    if (path.startsWith("/admin/employees")) return "employees";
    if (path.startsWith("/admin/teams")) return "teams";
    if (path.startsWith("/admin/users")) return "users";
    if (path.startsWith("/admin/history")) return "history";
    if (path.startsWith("/admin/info")) return "info";
    return "yards";
  };

  return (
    <div className="border-b border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-900">
      <div className="container mx-auto px-4">
        <Tabs.Root value={getActiveTab()}>
          <Tabs.List>
            <Link to="/admin/yards">
              <Tabs.Trigger value="yards">Chantiers</Tabs.Trigger>
            </Link>
            <Link to="/admin/companies">
              <Tabs.Trigger value="companies">Entreprises</Tabs.Trigger>
            </Link>
            <Link to="/admin/contracts">
              <Tabs.Trigger value="contracts">Contrats</Tabs.Trigger>
            </Link>
            <Link to="/admin/employees">
              <Tabs.Trigger value="employees">Employés</Tabs.Trigger>
            </Link>
            <Link to="/admin/teams">
              <Tabs.Trigger value="teams">Équipes</Tabs.Trigger>
            </Link>
            <Link to="/admin/users">
              <Tabs.Trigger value="users">Utilisateurs</Tabs.Trigger>
            </Link>
            <Link to="/admin/history">
              <Tabs.Trigger value="history">Historique</Tabs.Trigger>
            </Link>
            <Link to="/admin/info">
              <Tabs.Trigger value="info">Info</Tabs.Trigger>
            </Link>
            <Tabs.Indicator />
          </Tabs.List>
        </Tabs.Root>
      </div>
    </div>
  );
}

export type AdminNavProps = Record<string, never>;
